var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLiver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 258,
    height: 258,
    viewBox: "0 0 258 258",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M204.893 0H111.143C37.1289 0 4 56.0541 4 111.607V187.5C4 209.341 4 250 17.3931 250C26.6499 250 32.729 237.781 38.5874 223.202C39.5674 220.757 40.5435 218.244 41.5366 215.698C50.4668 192.732 61.4439 164.502 87.8047 161.063C89.6221 160.828 91.4531 160.712 93.2856 160.714C96.3481 160.714 99.2583 160.56 102.11 160.341C102.939 160.277 103.761 160.203 104.574 160.12C106.868 159.885 109.098 159.577 111.263 159.195C112.103 159.046 112.942 158.892 113.767 158.719C119.013 157.673 124.124 156.032 129 153.83V120.535C129.456 111.482 124.605 102.991 116.575 98.785C105.729 92.3914 87.8887 89.2855 62.0361 89.2855C61.8955 89.2645 61.7563 89.2366 61.6187 89.2015C60.9248 94.6766 57.6812 99.4998 52.8721 102.208C50.6675 103.304 47.9922 102.408 46.8911 100.206C45.79 98.0047 46.6792 95.327 48.8784 94.221C51.8457 92.0521 53.4526 88.4813 53.1074 84.8216C53.4526 81.1619 51.8462 77.5912 48.8784 75.4222C47.4478 74.7113 46.5059 73.2899 46.4092 71.6952C46.312 70.1004 47.0747 68.5755 48.4087 67.6962C49.7427 66.8168 51.4448 66.7176 52.8721 67.4354C57.6812 70.1429 60.9248 74.9666 61.6187 80.4417C61.7563 80.4066 61.8955 80.3783 62.0361 80.3577C89.2891 80.3577 108.517 83.8099 120.79 90.9075L122.047 91.4031C128.072 93.7879 133.77 96.0355 138.409 93.6595C143.122 91.2464 147.019 84.075 149.988 72.3451C152.041 60.2054 156.532 43.1396 165.853 32.7353C172.862 26.2778 181.973 22.5786 191.5 22.3212C191.641 22.3422 191.78 22.3701 191.917 22.4052C192.611 16.9301 195.855 12.1064 200.664 9.39891C202.869 8.30321 205.544 9.19871 206.645 11.4004C207.746 13.602 206.856 16.2798 204.657 17.3857C201.69 19.5546 200.083 23.1259 200.428 26.7851C200.083 30.4448 201.689 34.0156 204.657 36.1845C206.856 37.2905 207.746 39.9682 206.645 42.1698C205.543 44.3715 202.868 45.267 200.664 44.1713C195.855 41.4638 192.611 36.6401 191.917 31.165C191.78 31.2011 191.641 31.2289 191.5 31.2499C184.422 31.4931 177.647 34.1865 172.335 38.8705C166.249 45.6718 161.484 57.9462 158.715 74.1903C156.466 89.5316 155.486 105.033 155.786 120.535V132.431L155.864 132.343C157.817 130.216 159.688 128.178 161.558 126.308C166.942 120.922 170.452 112.37 174.515 102.47C179.703 89.8289 185.58 75.5008 197.272 63.808C206.052 55.8734 215.897 49.2035 226.521 43.9911C241.266 35.8735 254 28.8632 254 17.8569C254 5.26415 247.177 0 204.893 0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M127.94 163.908C128.289 164.129 128.669 164.309 129 164.553V163.494C128.648 163.635 128.296 163.773 127.94 163.908Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M108.995 168.609C106.926 168.886 104.81 169.105 102.644 169.268C102.047 169.313 101.448 169.361 100.842 169.397C98.381 169.542 95.8785 169.642 93.2858 169.642C69.024 169.642 59.2804 194.704 49.859 218.941C49.1027 220.891 48.3448 222.824 47.5856 224.738L47.5265 224.89C52.0909 235.773 61.2374 241.07 75.4283 241.07C87.4786 241.07 95.6046 238.705 100.278 233.842C106.944 226.901 106.456 214.748 105.942 201.881C105.497 190.775 105.004 178.583 109.547 168.552C109.368 168.578 109.174 168.584 108.995 168.609Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M145.022 100.021C144.219 100.616 143.369 101.146 142.48 101.605C139.867 102.937 136.972 103.618 134.039 103.591L133.949 103.583L133.804 103.591C136.627 108.785 138.049 114.625 137.928 120.535V245.535C137.928 248 139.927 249.999 142.392 249.999C144.858 249.999 146.857 248.001 146.857 245.535V120.535C146.857 114.708 146.857 106.837 147.288 98.0957C146.803 98.5703 146.289 98.9629 145.782 99.3755C145.526 99.5835 145.284 99.8281 145.022 100.021Z",
    fill: "black"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 258,
    height: 258,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiver);
export default __webpack_public_path__ + "static/media/Liver.f5e2bede4d2381a117edd3351f05bdc7.svg";
export { ForwardRef as ReactComponent };